import axios from "axios";

export default axios.create({
    baseURL: 'https://365euroapi.vincent365.nl/'
  });
